import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ErrorAlertDialogComponent } from '@components/dialogs/error-alert-dialog/error-alert-dialog.component';
import { LoginSocketService } from '@events/chat/login-socket.service';

@Injectable({ providedIn: 'root' })
export class LogoffReminderService {
  private subscription?: Subscription;

  constructor(
    private dialog: MatDialog,
    private loginSocket: LoginSocketService,
    private readonly translateService: TranslateService
  ) {}

  public init() {
    this.subscription?.unsubscribe();

    this.subscription = this.loginSocket.newLogoffReminder$.subscribe((data) => {
      const message = this.translateService
        .instant('LOGOFF_REMINDER_MESSAGE')
        .replace('{minutes}', data?.logoffReminder ?? 10);
      this.dialog.open(ErrorAlertDialogComponent, {
        data: message,
      });
    });
  }
}
